import React from 'react'
import styles from './styles'
import { Typography, withStyles } from '@material-ui/core'
import Badge from './badge'
import { CoreButton } from '../core'
const UpgradePopup = props => {
  const {
    upgradeButtonText,
    upgradeDescription,
    planName,
    onClose,
    classes,
  } = props
  return (
    <div className={classes.scormExportUpgradePopupContainer}>
      <img src="/assets/scorm-upgrade-rocket.png" height={'100%'}></img>
      <div className={classes.scormExportUpgradePopupContainer__right}>
        <div
          className={classes.scormExportUpgradePopupContainer__right__header}
        >
          <Typography fontSize={'20px'} fontWeight={600}>
            Upgrade to {planName}
          </Typography>
          <Badge />
        </div>
        {upgradeDescription && upgradeDescription}
        <div className={classes.buttons}>
          <CoreButton
            variant="text"
            onClick={() => onClose()}
            color="secondary"
          >
            <Typography fontSize={'14px'} fontWeight={500} color={'#637381'}>
              Not Now
            </Typography>
          </CoreButton>
          <CoreButton
            variant="contained"
            onClick={() => window.open('/pricing')}
          >
            {upgradeButtonText}
          </CoreButton>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(UpgradePopup)
